import { Box, Divider, Typography } from "@material-ui/core"
import PropTypes from "prop-types"
import React, { useMemo } from "react"
import useStyles from "./styles"

const StatusFilters = ({ setStatusState, statusState, statusNumber, type }) => {
  const classes = useStyles()

  const generalStatus = [
    { type: "published", label: "Published", route: "#published" },
    { type: "unpublished", label: "Unpublished", route: "#unpublished" },
    { type: "draft", label: "Draft", route: "#draft" },
    { type: "archived", label: "Archived", route: "#archived" },
  ]

  const courseStatus = [
    { type: "published", label: "Published", route: "#published" },
    { type: "unpublished", label: "Unpublished", route: "#unpublished" },
    { type: "draft", label: "Draft", route: "#draft" },
    { type: "archived", label: "Archived", route: "#archived" },
    { type: "scheduled", label: "Scheduled", route: "#scheduled" },
  ]

  const certStatus = [
    { type: "published", label: "Published", route: "#published" },
    { type: "unpublished", label: "Unpublished", route: "#unpublished" },
    { type: "draft", label: "Draft", route: "#draft" },
  ]

  const statusArray = useMemo(() => {
    if (type === "courses") {
      return courseStatus
    } else if (type === "certifications") {
      return certStatus
    } else {
      return generalStatus
    }
  }, [type])

  const handleClick = (status) => {
    window.location.hash = status.route
    setStatusState(status.type)
  }

  return (
    <Box className={classes.container}>
      {statusArray.map((status, i) => {
        return (
          <Box className={classes.buttonContainer} key={i}>
            <Typography
              className={classes.button}
              onClick={() => handleClick(status)}
              style={
                statusState === status.type
                  ? { color: "#092958", fontWeight: "bold" }
                  : { color: "#808080" }
              }
            >
              {status.label}{" "}
              {statusNumber[status.type] ? statusNumber[status.type] : "0"}
            </Typography>
            <Divider />
          </Box>
        )
      })}
    </Box>
  )
}

StatusFilters.propTypes = {
  setStatusState: PropTypes.func,
  statusState: PropTypes.string,
  statusNumber: PropTypes.object,
  type: PropTypes.string,
}

export default StatusFilters
